const getExpirationDate = (_mins) => {
	var expire = new Date();
	var expireTime = Date.now() + 1000 * (_mins ? _mins : 60 * 15);
	expire.setTime(expireTime);

	// return expire.toGMTString();
	return expire.toUTCString();
}

const _getCookie = (name) => {
	var value = window.document.cookie;
	var start = value.indexOf(` ${name}=`);
	start = (start == -1 ? value.indexOf(`${name}=`) : start);
	value = (start == -1 ? "" : value);

	start = value.indexOf("=", start) + 1;
    var end = value.indexOf(";", start);
    end = (end == -1 ? value.length : end);

	value = unescape(value.substring(start, end));

	return value.length == 0 ? false : value;
}

const _setCookie = (name, value, mins) => {
	window.document.cookie = `${name}=${value};expires=${getExpirationDate(mins)}; path=/`
}

const _delCookie = (name) => {
	if (_getCookie(name)) {
		window.document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
	}
}

export {
    _getCookie,
	_setCookie,
	_delCookie
}



// WEBPACK FOOTER //
// ./src/Components/Services/Cookies.js